// @flow
import { useFormikContext } from 'formik'
import * as React from 'react'

type Props = {
  onChange: Function,
}

function FormChangesListener({ onChange }: Props): React.Node {
  const { values } = useFormikContext()

  React.useEffect(() => {
    onChange(values)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values])

  return null
}

export default FormChangesListener
